import { render } from "./StructureSurveyUser.vue?vue&type=template&id=61a14b77"
import script from "./StructureSurveyUser.vue?vue&type=script&lang=js"
export * from "./StructureSurveyUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__